module.exports = __webpack_public_path__ + "static/media/admin.21f2d510.png";